export enum Status {
  'ACTIVE' = 1,
  'BLOCKED' = 2,
  'ARCHIVED' = 3
}
